<template>
    <div class="selectedCourseBanner">
        <div class="selectedCourse">
            <span>{{year}}学年要求完成专业科目{{netClassData.year_class_hour}}学时</span>
            <span>已选课：{{ netClassData.total }}门课程（含{{netClassData.class_hour}}学时）</span>
            <span>已学完：{{ netClassData.complete }}门课程（含{{netClassData.studyHours}}学时）</span>
        </div>

        <div class="learnTotalProcess">
            学习总进度：
            <el-progress :percentage="netClassData.totalPro" class="studyProgress"></el-progress>
            <!-- <div class="processBarBox">

                <span class="processBar"></span>
                <span class="currentProcessBar" :style="{width:netClassData.totalPro+'%'}"></span>
                <span class="totalProNum">{{netClassData.totalPro}}%</span>
            </div> -->
        </div>
    </div>
</template>
<script>
export default {
    props: {
        netClassData: {
            type: Object
        },
        year: {
            // type: String
        },
    },
    watch: {
        netClassData () {
            this.data = this.getTotalPro(this.netClassData)
        }
    },
    data () {
        return {
            data: {}
        }
    },
    methods: {
        getTotalPro (list) {
            if (!list.courses.length) {
                list['totalPro'] = 0;
                list['studyCredit'] = 0;
                list['studyHours'] = 0 ;
                return list;
            }

            let total = 0;
            let studyCredit = 0;
            let studyHours=0;

            list.courses.map(item => {
                total += item.progress;

                if (item.progress == 100) {
                    studyCredit += Number(item.credit);
                    studyHours += Number(item.class_hour);
                }
            })

            //已学完多少学分
            list['studyCredit'] = studyCredit.toFixed(1);
            list['studyHours'] = studyHours.toFixed(1);
            //总进度
            list['totalPro'] = parseInt(total / list.total);
            return list;
        }

    }
}
</script>
<style lang="stylus" scoped>
.selectedCourseBanner
    min-height 100px
    margin-top 60px
    background url('../../../assets/images/myCourseBg.png') no-repeat center
    background-size cover
    padding 20px 50px
    box-sizing border-box
    color #fff
.selectedCourse span
    font-size 18px
    margin-right 30px
.learnTotalProcess
    margin-top 10px
// .processBarBox
//     display inline-block
//     position relative
// .processBar
//     display inline-block
//     width 600px
//     height 5px
//     background #fff
//     border-radius 180px
// .processBarBox
//     position relative
// .learnTotalProcess
//     margin-top 5px
// .selectedCourse span
//     font-size 18px
//     margin-right 30px
// .currentProcessBar
//     position absolute
//     height 5px
//     width 100px
//     background-image -webkit-linear-gradient(left, #4bb7fc, #0173ff)
//     background-image -o-linear-gradient(left, #4bb7fc, #0173ff)
//     background-image -ms-linear-gradient(left, #4bb7fc, #0173ff)
//     background-image linear-gradient(left, #4bb7fc, #0173ff)
//     border-radius 180px
//     top 13px
//     left 0
//     width 100%
//     right 0
</style>
<style lang="stylus">
.studyProgress
    width 600px
    display inline-block
    .el-progress-bar__inner
        background-image -webkit-gradient(linear,left top,right top,from(#4bb7fc),to(#0173ff))
    .el-progress__text
        color #fff
        font-size 16px!important
</style>


// WEBPACK FOOTER //
// src/components/my/myCourse/netClassPross.vue